<template>
  <a-card :bordered="false">
    <div class="table-operator" style="line-height: 50px;">
      <a-button type="primary" icon="plus" @click="handleInsert"
        >添加分类
      </a-button>
      <a-button type="default" icon="delete" @click="handleDelete"
        >批量删除
      </a-button>
      <a-upload
        v-decorator="[
          'file',
          {
            valuePropName: 'file'
          }
        ]"
        name="file"
        :multiple="false"
        :action="catalogue"
        :headers="headers"
        :file-list="fileList"
        @change="handleChange"
        :showUploadList="false"
      >
        <a-button> <a-icon type="upload" />批量导入</a-button>
      </a-upload>
      <a-button icon="arrow-down"
        ><a href="https://yqfk.jtit.com.cn/upload/jszy/资源目录导入模版.xls"
          >下载导入模板</a
        ></a-button
      >
    </div>

    <!--    <a-alert>-->
    <!--      <span slot="message"-->
    <!--        >当前选择：{{ names }} <a @click="onCancelSelect">取消选择</a></span-->
    <!--      >-->
    <!--    </a-alert>-->
    <a-tree
      checkable
      :checked-keys="ids"
      :selected-keys="selectId"
      :tree-data="$store.getters.resource.resource"
      :replace-fields="replaceFields"
      @check="handleCheck"
      @select="handleSelect"
    >
    </a-tree>
    <edit ref="edit" @onAddOk="onAddOk" />
  </a-card>
</template>
<script>
import storage from "store";

import { USER, USER_TOKEN } from "@/store/mutation-types";
import { UPLOAD_WARNING_MESSAGE } from "@/constants/upload";

import edit from "./modules/treeEdit";
//api
import { del } from "@/api/base/tree/manager";

import {
  WARN_MESSAGE_TITLE,
  NOTICE_CHOICE_DELETE_ITEMS
} from "@/constants/message";

export default {
  components: {
    edit
  },
  data() {
    return {
      // tree
      // 所有选中id列表
      ids: [],
      // 展示当前选择名称
      names: "",
      // 选择的id
      selectId: [],
      replaceFields: { children: "jtypes", title: "name", key: "id" },
      // upload
      catalogue: window._CONFIG["catalogue"], //上传路径
      headers: { user_token: storage.get(USER_TOKEN) },
      user: storage.get(USER),
      fileList: []
    };
  },
  methods: {
    // uploadHead({file}){
    //   console.log('file', file)
    // },
    handleChange({ file, fileList }) {
      console.log("file", file);
      this.fileList = fileList;
      console.log("this.fileList", this.fileList);
      console.log("this.fileList", this.fileList[0].response.code);
      if (this.fileList[0].response.code == 0) {
        this.$message.warning("上传成功");
        // 重新加载数据
        this.fileList = [];
        this.$store.dispatch("resource");
      } else {
        this.$notification.warning({
          message: UPLOAD_WARNING_MESSAGE
        });
        this.fileList = [];
      }
    },
    // 添加分类
    handleInsert() {
      this.$refs.edit.show();
    },
    // 批量删除
    handleDelete() {
      let that = this;

      console.log(" === handleDelete === ");

      // 数据校验
      if (0 == that.ids.length) {
        that.$notification.warn({
          message: WARN_MESSAGE_TITLE,
          description: NOTICE_CHOICE_DELETE_ITEMS,
          duration: 1
        });

        return;
      }
      this.$confirm({
        title: WARN_MESSAGE_TITLE,
        content: "是否确认删除选中的分类",
        onOk() {
          // 删除
          del({ ids: that.ids.toString() }).then(res => {
            that.$notification[res.resultCode == 1 ? "success" : "error"]({
              message: res.message
            });

            if (res.resultCode == 1) {
              // console.log("=== ids:", that.ids, "selectid:", that.selectId);
              // 重置选择项
              that.handleSelect("");

              // 重置
              that.onCancelSelect();

              // 重新加载数据
              that.$store.dispatch("resource");
            }
          });
        }
      });
    },
    // 导入
    handleUpdate() {},
    // downloadModel(){
    //   window.open(
    //     window._CONFIG+"/src/assets/file/资源目录导入模版.xls"
    //   )
    // },
    // 树复选框选中事件
    handleCheck(ids) {
      this.ids = ids;
      this.currentSelect();
    },

    // 树节点点击事件
    handleSelect(id) {
      // console.log("handleSelect:", id);
      this.$emit("handleSelect", id.toString());
    },

    // 添加分类完成
    onAddOk() {
      // console.log(" === onAddOk === ");

      // 重新加载数据
      this.$store.dispatch("resource");
    },

    // 当前选择
    currentSelect() {
      let _this = this;
      let values = [];
      this.ids.map(id => {
        let name = _this.getSelectName(
          this.$store.getters.resource.resource,
          id
        );
        if (null != name) {
          values.push(name);
        }
      });

      this.names = values.toString();
    },

    // 获取选择的名字
    getSelectName(items, id) {
      let name = null;
      for (let i = 0; i < items.length; i++) {
        let item = items[i];
        if (item.id === id) {
          name = item.name;
          break;
        } else {
          if (!item.leaf) {
            // 判断是否有子节点被选择
            name = this.getSelectName(item.jtypes, id);
            if (null != name) break;
          }
        }
      }

      return name;
    },

    // 取消选择
    onCancelSelect() {
      console.log(" === onCancelSelect ");

      this.ids = [];
      this.names = "";
    }
  }
};
</script>
<style></style>
